import React from 'react';

interface Props {
  className?: string;
}

export class TreatmentGuideIcon extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <svg
        {...this.props}
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fillRule="evenodd">
          <path d="M22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 Z M0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z" />
          <polygon points="12 22 10.6183467 15.0917337 6.34314575 17.6568542 8.90826634 13.3816533 2 12 8.90826634 10.6183467 6.34314575 6.34314575 10.6183467 8.90826634 12 2 13.3816533 8.90826634 17.6568542 6.34314575 15.0917337 10.6183467 22 12 15.0917337 13.3816533 17.6568542 17.6568542 13.3816533 15.0917337" />
        </g>
      </svg>
    );
  }
}
